import React from 'react';
import { Box, Typography } from '@mui/material';
import './ActionAuditBanner.css';

const ActionAuditBanner = ({ variant = 'approved', fields = [] }) => {
  if (!fields.length) return null;

  const labelVariant = variant === 'rejected' || variant === 'disabled' ? variant : 'approved';

  return (
    <Box className={`audit-status-container ${variant}`}>
      {fields.map(({ label, value }) => (
        <Box key={label} className="audit-status-info">
          <Typography className={`audit-status-label ${labelVariant}`}>{label}</Typography>
          <Typography className="audit-status-value">{value || '---'}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default ActionAuditBanner;
